import { History, ListTree, Route } from "lucide-react";

import useTranslations from "@/shared/lang/useTranslations";

export type TaxTabId = "corridors" | "history" | "rules";

const INTRO = {
  corridors: { icon: Route, key: "tab_intro_corridors" },
  history: { icon: History, key: "tab_intro_history" },
  rules: { icon: ListTree, key: "tab_intro_rules" },
} as const;

export function TaxTabIntro({ tab }: { tab: TaxTabId }) {
  const { t } = useTranslations("paymentTaxes");
  const { icon: Icon, key } = INTRO[tab];
  return (
    <p className="flex items-start gap-2.5 rounded-xl bg-muted/50 px-4 py-3 text-sm text-muted-foreground">
      <Icon className="mt-0.5 size-4 shrink-0 text-foreground/70" aria-hidden="true" />
      {t(key)}
    </p>
  );
}
